import BrandProductImage from './BrandProductImage';
export default BrandProductImage;
